<template>
	<div class="width-100 flex-column height-100">
		<div class="header-container width-100 height-100 display-flex flex-column flex-justify-space-between">
			<div>
				<h3 class="reg mb-6">Marketplace</h3>
				<div class="width-100 flex-centerize">
					<div class="header-title flex-centerize flex-column">
						Supercharge your workflow
						<div class="subtitle mt-4">Install features from the marketplace</div>
					</div>
				</div>
			</div>
			<div>
				<div class="footer-container display-flex flex-row flex-align-center flex-justify-space-between">
					<div class="display-flex flex-column mr-10">
						<div class="apps-description">Add your apps to see more features, click on an app to filter.</div>
						<SelectFavoriteAppsMenu ref="menu" class="mt-2 mb-6" />
					</div>
					<div class="display-flex flex-row flex-align-center">
						<MarketplaceExactMatch v-if="allCalculatedDirectoryAppsIds.length > 0" />
						<MarketplaceFeatureTypeDropdown class="pt-6 ml-4" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { allCalculatedDirectoryAppsIds } from '@/store/modules/auth/getters';
import SelectFavoriteAppsMenu from '@/components/SelectFavoriteApps/SelectFavoriteAppsMenu.vue';
import MarketplaceExactMatch from '@/components/Marketplace/MarketplaceHeader/MarketplaceExactMatch.vue';
import MarketplaceFeatureTypeDropdown from '@/components/Marketplace/MarketplaceHeader/MarketplaceFeatureTypeDropdown.vue';
export default {
	name: 'MarketplaceHeader',
	components: {
		MarketplaceExactMatch,
		SelectFavoriteAppsMenu,
		MarketplaceFeatureTypeDropdown,
	},
	computed: {
		...mapGettersShorthand({ allCalculatedDirectoryAppsIds }),
	},
	methods: {
		openAddApps() {
			// Triggered from parent
			this.$refs.menu.open();
		},
	},
};
</script>
<style lang="scss" scoped>
.header-container {
	background: #f9fafc;
	padding: 32px 50px 0px 50px;
	border-bottom: 1px solid var(--border-color);
}
.header-title {
	width: 100%;
	text-align: center;
	max-width: 644px;
	height: 166px;
	background-size: contain;
	background-image: url('../../assets/icons/marketplace-header-background.png');

	color: #262626;
	font-size: 35px;
	font-weight: bold;
	letter-spacing: 0px;
}
.subtitle {
	font-size: 18px;
}

.exact-match-switch {
	::v-deep {
		.dark .v-input--switch__track {
			background: #707070 !important;
		}
		.dark.v-input--is-label-active .v-input--switch__track {
			background: var(--bold-border-color) !important;
		}
		.small {
			transform: scale(0.75);
		}
		.v-input--selection-controls {
			padding-top: 0px;
		}
		.v-input--switch__track {
			background: #ced0da !important;
			opacity: 1 !important;
			transition: all 0.15s;
		}
		.v-input--is-label-active .v-input--switch__track {
			opacity: 1 !important;
			background: var(--bold-border-color) !important;
		}
	}
}
.apps-description {
	font-size: 14px;
	color: #a3a3a3;
}
</style>
